module.exports = __webpack_public_path__ + "img/home-img-2.3bf1d26d.jpg";